import { useSelectSlice } from "@common/redux/selectors/useSelectSlice"
import { Layout } from "@kursk/components/Layout/Layout";
import styles from './SingleStream.module.scss';
import { streamSlice } from "@common/redux/slices/streams.slice";
import { Socials } from "@kursk/components/pages/Home/Socials/Socials";
import { Tags } from "@kursk/components/ui/Tags/Tags";
import React from "react";
import { StreamsHeader } from "./StreamsHeader/StreamsHeader";
import { StreamsContent } from "./StreamsContent/StreamsContent";
import { SocialLinks } from "@kursk/components/ui/SocialLinks/SocialLinks";
import { SubscribeFooterForm } from "@kursk/components/ui/SubscribeFooterForm/SubscribeFooterForm";
import { SubscribeStreamsForm } from "@kursk/components/pages/SingleStream/SubscribeStreamsForm";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { getAddress } from "@kursk/utils/getAddress";
import { IAffiliationEvent, IAffiliationLocation, IAffiliationPlace } from "@common/redux/types/invoices";

function getPlace(affiliation: IAffiliationEvent | IAffiliationPlace | IAffiliationLocation) {
  if (affiliation.type === 'entity') {
    return { eventName: affiliation.event.name }
  }
  if (affiliation.type === 'location') {
    return { address: getAddress(affiliation.location.address) };
  }
  if (affiliation.type === 'place') {
    return { address: affiliation.place.name }
  }
}

export const SingleStream = () => {
  const { stream } = useSelectSlice(streamSlice);
  const { forStreamsStreams } = useSelectSlice(recommendationSlice);

  if (!stream) {
    return <></>;
  }
  const isStart = stream.start < +new Date();

  return (
    <Layout key={`stream_${stream._id}`}>
      <SeoMetaTitles
        page="singleStream"
        entity={{
          name: stream.name,
          image: stream.image,
          liveDate: stream.start,
          ...getPlace(stream.affiliation),
        }}
        showOgImage={true}
      />
      {!isStart && (
        <section className={styles.streams_subscribe}>
          <SubscribeStreamsForm streamId={stream._id}/>
        </section>
      )}
      <section className={styles.streams_header}>
        <StreamsHeader entity={stream}/>
      </section>
      <section className={styles.streams_socialLinks}>
        <SocialLinks/>
      </section>
      <section className={styles.streams_content}>
        <StreamsContent entity={stream}/>
      </section>
      <section className={styles.streams_tags}>
        <Tags link={'/streams'} className={styles.streams_inner} tags={stream?.tags}/>
      </section>
      <RecommendationsBlock
        entityType="streams"
        data={forStreamsStreams}
        title={'Ближайшие трансляции'}
        goTo={'/streams'}
        goToTitle={'все трансляции'}/>
      {isStart && <section className={styles.streams_subscribe}>
        <SubscribeFooterForm/>
      </section>}
      <section className={styles.streams_socials}>
        <Socials/>
      </section>
    </Layout>
  );
}
